import React, { useEffect, useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { ArrowIcon } from 'assets/icons'
import { Button, InputText } from 'components/atoms'
import { theme } from 'utils/theme'
import { contentTypesNames } from 'interfaces/contentTypeInterface'
import { FULL_SCHEDULE, HOME } from 'constants/routesConstants'
import { DASHBOARD, GENERAL_EVENTS, SPORT_EVENTS, MQTT_TOPIC, BRAND } from 'constants/appConstants'
import { mqttUnSubscribe } from 'services/mqtt-service'
import { MqttClientContext } from 'components/system/app'

import * as S from './styled'
import { useTheme } from 'styled-components'

const SearchBar = ({ location, handleSearch, handleStatus, isSearchMode }) => {
  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  const [locationBack, setLocationBack] = useState('')
  const { brand } = useTheme()

  const mqttClient = useContext(MqttClientContext)

  const [payload, setPayload] = useState({})

  mqttClient.on('message', (topic, message) => {
    setPayload({ topic, message: message.toString() })
  })

  const screenAppStorage = JSON.parse(localStorage.getItem('screenApp')).value

  const topic = `${MQTT_TOPIC}${screenAppStorage}`

  useEffect(() => {
    if (location.contentId) {
      setLocationBack(location.contentType)
    } else if (location.contentType === GENERAL_EVENTS || location.contentType === SPORT_EVENTS) {
      setLocationBack(FULL_SCHEDULE)
    } else {
      setLocationBack('dashboard')
    }
  }, [location])

  const isEvent = location.contentType === GENERAL_EVENTS || location.contentType === SPORT_EVENTS

  const RenderBackButton = () => {
    return !isEvent ? (
      <>
        {location.contentType === DASHBOARD ? (
          <S.NavigateBack
            onClick={() => {
              navigate(HOME)
              mqttUnSubscribe(mqttClient, topic)
            }}
            pill={true}
          >
            Logout
          </S.NavigateBack>
        ) : (
          <S.NavigateBack
            onClick={() => {
              navigate(locationBack)
            }}
          >
            Back to {contentTypesNames(locationBack)}
          </S.NavigateBack>
        )}
      </>
    ) : (
      <S.NavigateBack
        onClick={() => {
          navigate(FULL_SCHEDULE)
        }}
      >
        Back to Full Schedule
      </S.NavigateBack>
    )
  }

  const RenderCloseSearch = () => (
    <S.NavigateBack onClick={() => handleStatus(false)}>
      <Button label='Close search' classBtn='filter' />
    </S.NavigateBack>
  )

  useEffect(() => {
    handleSearch(search)
  }, [search])

  return (
    <S.SearchBar>
      <S.SearchBarContainer>
        {isSearchMode ? <RenderCloseSearch /> : <RenderBackButton />}
        <InputText
          value={search}
          onFocus={() => handleStatus(true)}
          onChange={event => setSearch(event.target.value)}
          placeholder='Search'
          width='463px'
          height='72px'
          icon={ArrowIcon}
          iconColor={brand === BRAND.ATH ? theme.colors.lightGold : theme.colors.white}
          iconWidth='25px'
          iconHeight='43px'
          className='search'
        />
      </S.SearchBarContainer>
    </S.SearchBar>
  )
}

SearchBar.defaultProps = {
  handleSearch: () => {},
  handleStatus: () => {},
  isSearchMode: false,
}

SearchBar.propTypes = {
  location: PropTypes.object.isRequired,
  handleSearch: PropTypes.func,
  handleStatus: PropTypes.func,
  isSearchMode: PropTypes.bool,
}

export default SearchBar
